"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _commonUtility = require("../utils/commonUtility");

var _Row = _interopRequireDefault(require("../Layout/Row"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _CheckedIcon = _interopRequireDefault(require("./CheckedIcon"));

var _styles = _interopRequireDefault(require("./styles"));

var _colors = require("../theme/colors");

var _excluded = ["id", "checked", "indeterminate", "onChange", "disabled", "value", "name", "style", "className", "checkedIcon", "children", "icon", "jss", "inputProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BtnCheckboxIndeterminate = function BtnCheckboxIndeterminate(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "15",
    height: "15",
    rx: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "9",
    height: "1.5",
    x: "3",
    y: "6.75",
    fill: "#FFF",
    rx: ".75"
  })));
};

BtnCheckboxIndeterminate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15"
};

var BtnCheckboxOff = function BtnCheckboxOff(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5 15h-10A2.503 2.503 0 0 1 0 12.5v-10C0 1.122 1.122 0 2.5 0h10C13.879 0 15 1.122 15 2.5v10c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v10c0 .827.673 1.5 1.5 1.5h10c.827 0 1.5-.673 1.5-1.5v-10c0-.827-.673-1.5-1.5-1.5h-10z"
  }));
};

BtnCheckboxOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
};
var useStyles = (0, _createStyles["default"])(function (theme) {
  return (0, _extends2["default"])({
    root: {
      position: 'relative',
      cursor: 'pointer'
    }
  }, (0, _styles["default"])(theme), {
    iconDisabled: {
      fill: _colors.gray300,
      backgroundColor: _colors.gray100
    },
    indeterminate: {
      fill: theme.palette.primary["default"]
    },
    disabled: {
      cursor: 'not-allowed',
      color: theme.palette.text.placeholder
    },
    input: {
      cursor: 'inherit',
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0,
      zIndex: 1
    }
  });
}, {
  name: 'Checkbox'
});
exports.useStyles = useStyles;

var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function Checkbox(_ref, ref) {
  var _cn2;

  var id = _ref.id,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? _noop["default"] : _ref$onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$checkedIcon = _ref.checkedIcon,
      checkedIcon = _ref$checkedIcon === void 0 ? null : _ref$checkedIcon,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });
  var inputId = (0, _react.useMemo)(function () {
    return id || (0, _commonUtility.uuid)();
  }, [id]);
  var SvgIcon = (0, _react.useMemo)(function () {
    if (indeterminate) return /*#__PURE__*/_react["default"].createElement(BtnCheckboxIndeterminate, {
      height: 16,
      width: 16
    });

    if (icon) {
      return checked ? checkedIcon : icon;
    }

    return checked ? /*#__PURE__*/_react["default"].createElement(_CheckedIcon["default"], {
      height: 16,
      width: 16
    }) : /*#__PURE__*/_react["default"].createElement(BtnCheckboxOff, {
      height: 16,
      width: 16
    });
  }, [checked, indeterminate, icon, checkedIcon]);
  return /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: inputId
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    wrap: false,
    align: "center",
    className: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, classes.disabled, disabled), className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    color: "primary"
  }, props, {
    size: "sm",
    component: "span",
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
    id: inputId,
    ref: ref,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    className: classes.input,
    name: name,
    value: value
  })), /*#__PURE__*/_react["default"].cloneElement(SvgIcon, {
    className: (0, _classnames["default"])(classes.icon, (_cn2 = {}, (0, _defineProperty2["default"])(_cn2, classes.uncheckedDefaultBg, !checked && !icon), (0, _defineProperty2["default"])(_cn2, classes.checked, checked), (0, _defineProperty2["default"])(_cn2, classes.indeterminate, indeterminate), (0, _defineProperty2["default"])(_cn2, classes.iconDisabled, disabled), _cn2))
  }))), children && /*#__PURE__*/_react["default"].createElement(_TextField["default"], null, children)));
});

Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports["default"] = _default;